export const SET_REGION = 'SET_REGION';

export const setRegion = () => dispatch =>
  dispatch({
    type: SET_REGION
  });
